import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectCurrentUser } from '../../features/auth/authSlice';

function RequirePasswordChange({ children }) {
  const user = useSelector(selectCurrentUser);
  const location = useLocation();
  
  // If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If user doesn't need to change password, redirect to dashboard
  if (!user.mustChangePassword) {
    return <Navigate to="/dashboard" replace />;
  }
  
  // Allow access to password change page
  return children;
}

export default RequirePasswordChange;